export { default as default } from './RightSidePanelComponent.jsx';